export const LANGUAGE_PREFERENCES_STORAGE_KEY = 'cr_language_preferences_v1';
export const LANGUAGE_PREFERENCES_VERSION = 1;
